<!--
 * @Author: your name
 * @Date: 2021-06-08 11:28:34
 * @LastEditTime: 2021-09-05 17:08:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fmg-project\pc\src\components\Head.vue
-->
<template>
  <div class="publicHead">
    <div class="headBox">
      <div class="head-l" @click.stop="drawer = true">
        <img src="@/assets/images/home/menu.png" />
        <p>{{ $t("Head.menu") }}</p>
      </div>
      <div class="logo">
        <img
          src="@/assets/images/public/logo.png"
          @click.stop="$store.dispatch('changeRouter', { path: '/' })"
        />
      </div>
      <div class="head-r">
        <div class="lang">
          <span @click.stop="changeLang(1)" :class="{ active: $i18n.locale == 'zh' }">CN</span>
          <span @click.stop="changeLang(2)" :class="{ active: $i18n.locale == 'en' }">EN</span>
        </div>
        <div class="login-info">
          <div class="info" v-if="$store.getters.isLogin">
            {{ user.token | tokenFilter }}
            <span>
              {{ getNetwork }}
              <img src="@/assets/images/public/arrow_icons.png" />
            </span>
            <p>
              <i
                v-for="(item, index) in chainList"
                @click.stop="changeNetwork(item.chain)"
                :key="index"
                :class="{ active: checkChainId(item.chain) }"
              >{{ item.name }}</i>
            </p>
          </div>
          <div
            class="connect"
            v-else
            @click.stop="$store.dispatch('changeRouter', { path: '/login' })"
          >{{ $t("Head.connect") }}</div>
        </div>
        <div class="user-info" @click.stop="goUser()">
          <img
            :src="
              (user && user.fileId) ||
              require('@/assets/images/public/user.png')
            "
          />
        </div>
      </div>
    </div>

    <el-drawer
      title="Menu"
      :with-header="false"
      :visible.sync="drawer"
      direction="ltr"
      :size="300"
      :before-close="closeModel"
    >
      <div class="menuModel">
        <div class="close" @click.stop="drawer = false">
          <span>{{ $t("Head.close") }}</span>
          <img src="@/assets/images/home/close.png" />
        </div>
        <ul>
          <li
            v-for="(item, index) in menuList"
            :key="index"
            :class="{ active: $route.path == item.path }"
            @click.stop="changeRouter(item)"
          >
            <img src="@/assets/images/home/rocket.png" />
            <p>{{ $t(item.title) }}</p>
            <img src="@/assets/images/home/rocket.png" />
          </li>
        </ul>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: false,
      chainId: null,
      chainList: [
        {
          name: "ETH",
          chain: 1
        },
        {
          name: "BSC",
          chain: 56
        },
        {
          name: "HECO",
          chain: 128
        }
      ],
      menuList: [
        {
          title: "Menu.home",
          path: "/"
        },
        {
          title: "Menu.drops",
          path: "/drops"
        },
        {
          title: "Menu.bazaar",
          path: "/bazaar"
        },
        {
          title: "Menu.news",
          path: "/news"
        },
        {
          title: "Menu.discover",
          path: "/discover"
        }
      ]
    };
  },
  computed: {
    ...mapState({ user: state => state.userInfo }),
    getNetwork() {
      let name = "invalid";
      for (let v of this.chainList) {
        if (v.chain == this.chainId) {
          name = v.name;
        }
      }
      return name;
    }
  },
  filters: {
    tokenFilter(item) {
      return item.replace(/^(.{5})(?:\w+)(.{5})$/, "$1...$2");
    }
  },
  methods: {
    async changeNetwork(id) {
      if (id == 1) {
        return this.$message({
          message: this.$t("Public.chainChange"),
          type: "warning"
        });
      }
      await window.CHAIN.WALLET.switchRPCSettings(id);
      location.reload();
    },
    checkChainId(id) {
      if (this.chainId === id) {
        return true;
      } else {
        return false;
      }
    },
    goUser() {
      if (this.$store.getters.isLogin) {
        this.$store.dispatch("changeRouter", { path: "/user" });
      }
    },
    changeRouter(item) {
      this.drawer = false;
      window.scrollTo(0, 0);
      this.$store.dispatch("changeRouter", { path: item.path });
    },
    changeLang(index) {
      if (index == 1) {
        localStorage.setItem("locale", "zh");
        this.$i18n.locale = "zh";
      } else {
        localStorage.setItem("locale", "en");
        this.$i18n.locale = "en";
      }
    },
    closeModel() {
      this.drawer = false;
    }
  },
  async mounted() {
    this.chainId = await window.CHAIN.WALLET.chainId();
  }
};
</script>
<style lang="less" scoped>
.menuModel {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  font-family: "Poppins-Bold", "Microsoft Yahei";
  font-weight: bold;
  font-size: 20px;
  .close {
    position: absolute;
    cursor: pointer;
    top: 45px;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 18px;
      margin-left: 25px;
    }
  }
  ul {
    width: 100%;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
      position: relative;
      margin-bottom: 45px;
      cursor: pointer;
      padding-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: calc(~"50% - 40px");
          width: 80px;
          height: 2px;
          background: #77c9c2;
        }
        img {
          opacity: 1;
        }
      }
      img {
        width: 26px;
        opacity: 0;
        transition: all 0.2s;
      }
      p {
        margin: 0 10px;
      }
    }
  }
}
.publicHead {
  .headBox {
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    width: 100%;
    height: 100px;
    color: #333;
    z-index: 99;
    backdrop-filter: blur(6px);
  }
  .logo {
    img {
      height: 24px;
    }
  }
  .head-l {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    cursor: pointer;
    img {
      width: 26px;
      margin-right: 8px;
    }
  }
  .head-r {
    position: absolute;
    top: 0;
    right: 45px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    .lang {
      span {
        margin-left: 14px;
        cursor: pointer;
        transition: all 0.2s;
        &.active {
          color: rgba(0, 0, 0, 0.5);
        }
        &:first-child {
          margin: 0;
          padding-right: 14px;
          border-right: 1px solid #707070;
        }
      }
    }
    .user-info {
      margin-left: 25px;
      img {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
    .login-info {
      margin-left: 60px;
      cursor: pointer;
      min-width: 100px;
      display: flex;
      align-items: flex-end;
      .info {
        height: 100%;
        display: flex;
        align-items: center;
        background: rgba(154, 154, 154, 0.1);
        border-radius: 22px;
        padding-left: 15px;
        height: 40px;
        font-size: 16px;
        position: relative;
        &:hover {
          p {
            opacity: 1;
            visibility: initial;
          }
        }
        span {
          background: rgba(154, 154, 154, 0.1);
          height: 100%;
          border-radius: 22px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 14px;
          img {
            height: 10px;
            margin-left: 10px;
            display: block;
          }
        }
        p {
          position: absolute;
          background: #fff;
          border-radius: 10px;
          left: 0;
          top: 100%;
          width: 100%;
          padding: 20px 10px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.2s;
          i {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
            cursor: pointer;
            color: rgba(0, 0, 0, 0.5);
            transition: all 0.2s;
            &:last-child {
              margin-bottom: 0;
            }
            &.active {
              color: rgba(0, 0, 0, 1);
            }
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Head.vue